export const KICK_FLAG = "xaltix_session_replaced";
export const LOGIN_PATH_KEY = "xaltix_login_path";

export const markSessionReplaced = () => {
  try { sessionStorage.setItem(KICK_FLAG, "1"); } catch {}
  if (window.location.pathname.startsWith("/agent")) return;
  let to = "/login";
  try { to = localStorage.getItem(LOGIN_PATH_KEY) || "/login"; } catch {}
  window.location.assign(to);
};
